import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const ethereum: VToken[] = [
  {
    chainId: 1,
    address: '0x8716554364f20BCA783cb2BAA744d39361fd1D8d',
    decimals: 8,
    symbol: 'vWBTC_Core',
    underlyingToken: tokens[1][3],
  },
  {
    chainId: 1,
    address: '0x7c8ff7d2A1372433726f879BD945fFb250B94c65',
    decimals: 8,
    symbol: 'vWETH_Core',
    underlyingToken: tokens[1][4],
  },
  {
    chainId: 1,
    address: '0x17C07e0c232f2f80DfDbd7a95b942D893A4C5ACb',
    decimals: 8,
    symbol: 'vUSDC_Core',
    underlyingToken: tokens[1][5],
  },
  {
    chainId: 1,
    address: '0x8C3e3821259B82fFb32B2450A95d2dcbf161C24E',
    decimals: 8,
    symbol: 'vUSDT_Core',
    underlyingToken: tokens[1][6],
  },
  {
    chainId: 1,
    address: '0x672208C10aaAA2F9A6719F449C4C8227bc0BC202',
    decimals: 8,
    symbol: 'vcrvUSD_Core',
    underlyingToken: tokens[1][7],
  },
  {
    chainId: 1,
    address: '0xd8AdD9B41D4E1cd64Edad8722AB0bA8D35536657',
    decimals: 8,
    symbol: 'vDAI_Core',
    underlyingToken: tokens[1][11],
  },
  {
    chainId: 1,
    address: '0x13eB80FDBe5C5f4a7039728E258A6f05fb3B912b',
    decimals: 8,
    symbol: 'vTUSD_Core',
    underlyingToken: tokens[1][10],
  },
  {
    chainId: 1,
    address: '0x4fAfbDc4F2a9876Bd1764827b26fb8dc4FD1dB95',
    decimals: 8,
    symbol: 'vFRAX_Core',
    underlyingToken: tokens[1][12],
  },
  {
    chainId: 1,
    address: '0x17142a05fe678e9584FA1d88EfAC1bF181bF7ABe',
    decimals: 8,
    symbol: 'vsFRAX_Core',
    underlyingToken: tokens[1][13],
  },
  {
    chainId: 1,
    address: '0x256AdDBe0a387c98f487e44b85c29eb983413c5e',
    decimals: 8,
    symbol: 'vEIGEN',
    underlyingToken: tokens[1][20],
  },
  {
    chainId: 1,
    address: '0x325cEB02fe1C2fF816A83a5770eA0E88e2faEcF2',
    decimals: 8,
    symbol: 'veBTC',
    underlyingToken: tokens[1][21],
  },
  {
    chainId: 1,
    address: '0x25C20e6e110A1cE3FEbaCC8b7E48368c7b2F0C91',
    decimals: 8,
    symbol: 'vLBTC_Core',
    underlyingToken: tokens[1][22],
  },
  {
    chainId: 1,
    address: '0x0c6B19287999f1e31a5c0a44393b24B62D2C0468',
    decimals: 8,
    symbol: 'vUSDS_Core',
    underlyingToken: tokens[1][27],
  },
  {
    chainId: 1,
    address: '0xE36Ae842DbbD7aE372ebA02C8239cd431cC063d6',
    decimals: 8,
    symbol: 'vsUSDS_Core',
    underlyingToken: tokens[1][26],
  },
  {
    chainId: 1,
    address: '0x0Ec5488e4F8f319213a14cab188E01fB8517Faa8',
    decimals: 8,
    symbol: 'vBAL_Core',
    underlyingToken: tokens[1][28],
  },
  {
    chainId: 1,
    address: '0xf87c0a64dc3a8622D6c63265FA29137788163879',
    decimals: 8,
    symbol: 'vyvUSDC-1_Core',
    underlyingToken: tokens[1][29],
  },
  {
    chainId: 1,
    address: '0x475d0C68a8CD275c15D1F01F4f291804E445F677',
    decimals: 8,
    symbol: 'vyvUSDT-1_Core',
    underlyingToken: tokens[1][30],
  },
  {
    chainId: 1,
    address: '0x520d67226Bc904aC122dcE66ed2f8f61AA1ED764',
    decimals: 8,
    symbol: 'vyvUSDS-1_Core',
    underlyingToken: tokens[1][31],
  },
  {
    chainId: 1,
    address: '0xba3916302cBA4aBcB51a01e706fC6051AaF272A0',
    decimals: 8,
    symbol: 'vyvWETH-1_Core',
    underlyingToken: tokens[1][32],
  },
  {
    chainId: 1,
    address: '0xc42E4bfb996ED35235bda505430cBE404Eb49F77',
    decimals: 8,
    symbol: 'vweETHs_Core',
    underlyingToken: tokens[1][18],
  },
  {
    chainId: 1,
    address: '0xa836ce315b7A6Bb19397Ee996551659B1D92298e',
    decimals: 8,
    symbol: 'vsUSDe_Core',
    underlyingToken: tokens[1][23],
  },
  {
    chainId: 1,
    address: '0xa0EE2bAA024cC3AA1BC9395522D07B7970Ca75b3',
    decimals: 8,
    symbol: 'vUSDe_Core',
    underlyingToken: tokens[1][35],
  },
  {
    chainId: 1,
    address: '0x5e35C312862d53FD566737892aDCf010cb4928F7',
    decimals: 8,
    symbol: 'vtBTC_Core',
    underlyingToken: tokens[1][34],
  },
  {
    chainId: 1,
    address: '0x2d499800239C4CD3012473Cb1EAE33562F0A6933',
    decimals: 8,
    symbol: 'vcrvUSD_Curve',
    underlyingToken: tokens[1][7],
  },
  {
    chainId: 1,
    address: '0x30aD10Bd5Be62CAb37863C2BfcC6E8fb4fD85BDa',
    decimals: 8,
    symbol: 'vCRV_Curve',
    underlyingToken: tokens[1][8],
  },
  {
    chainId: 1,
    address: '0x4a240F0ee138697726C8a3E43eFE6Ac3593432CB',
    decimals: 8,
    symbol: 'vwstETH_LiquidStakedETH',
    underlyingToken: tokens[1][2],
  },
  {
    chainId: 1,
    address: '0xc82780Db1257C788F262FBbDA960B3706Dfdcaf2',
    decimals: 8,
    symbol: 'vWETH_LiquidStakedETH',
    underlyingToken: tokens[1][4],
  },
  {
    chainId: 1,
    address: '0xb4933AF59868986316Ed37fa865C829Eba2df0C7',
    decimals: 8,
    symbol: 'vweETH_LiquidStakedETH',
    underlyingToken: tokens[1][9],
  },
  {
    chainId: 1,
    address: '0xF9E9Fe17C00a8B96a8ac20c4E344C8688D7b947E',
    decimals: 8,
    symbol: 'vsfrxETH_LiquidStakedETH',
    underlyingToken: tokens[1][16],
  },
  {
    chainId: 1,
    address: '0xA854D35664c658280fFf27B6eDC6C4195c3229B3',
    decimals: 8,
    symbol: 'vezETH_LiquidStakedETH',
    underlyingToken: tokens[1][17],
  },
  {
    chainId: 1,
    address: '0xEF26C64bC06A8dE4CA5D31f119835f9A1d9433b9',
    decimals: 8,
    symbol: 'vweETHs_LiquidStakedETH',
    underlyingToken: tokens[1][18],
  },
  {
    chainId: 1,
    address: '0xE0ee5dDeBFe0abe0a4Af50299D68b74Cec31668e',
    decimals: 8,
    symbol: 'vpufETH_LiquidStakedETH',
    underlyingToken: tokens[1][19],
  },
];
